export { default as SeoQuery } from './SeoQuery';
export { default as SeoSearchQuery } from './SeoSearchQuery';
export { default as SeoSearchCustomQuery } from './SeoSearchCustomQuery';
export { default as SeoDepartmentQuery } from './SeoDepartmentQuery';
export { default as SeoPdpQuery } from './SeoPdpQuery';
export { default as SeoRelatedLinkQuery } from './SeoRelatedLinkQuery';
export { default as SeoDepartmentCategoriesQuery } from './SeoDepartmentCategoriesQuery';